import React, { Component } from "react";

import "./IndustrialCard.scss";
import CondominioService from "services/condominio";

import IconChangeProgram from "assets/illustrations/ic_changeprogram_service.png";
import IconNextDelivery from "assets/illustrations/ic_nextdelivery_service.png";
import { IconCheck } from "../../Icons/Icons";
import { iconTools } from "assets/icons/icon-tools";
import { iconFaucet } from "assets/icons/icon-faucet";
import { iconClipboard } from "assets/icons/icon-clipboard";
import IconRepresentativeContact from "assets/illustrations/ic_representativecontact_service.png";
import { iconCalendarReload } from "assets/icons/icon-calendar-reload";
import { iconPencilWriting } from "assets/icons/icon-pencil-writing";
import { iconContract } from "assets/icons/icon-contract";
import { iconUmbrella } from "assets/icons/icon-umbrella";
import { iconGasPump } from "assets/icons/icon-gas-pump";

export default class IndustrialCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.props.checked || false,
      selectedCondominio: CondominioService.selectAll
        ? "all"
        : CondominioService.selected || {},
    };
  }

  filterImage() {
    if (this.props.image === "12;;") return iconFaucet;
    if (this.props.image === "14;;") return iconTools;
    if (this.props.image === "15;;") return iconFaucet;
    if (this.props.image === "17;;") return iconClipboard;
    if (this.props.image === "18;;") return iconCalendarReload;
    if (this.props.image === "19;;") return iconUmbrella;
    if (this.props.image === "20;;") return IconRepresentativeContact;
    if (this.props.image === "21;;") return iconPencilWriting;
    if (this.props.image === "22;;") return iconGasPump;
    if (this.props.image === "23;;") return IconChangeProgram;
    if (this.props.image === "24;;") return iconContract;
    else return IconNextDelivery;
  }

  componentDidMount() {
    if (this.props.cardClass !== "service" && this.props.selectedService)
      this.props.onDetail(9);
  }

  render() {
    const { selectedCondominio } = this.state;

    return (
      <div
        className={`delivery-card ${(this.state.checked && "checked") || ""}`}
        onClick={() => this.props.onDetail(this.props.serviceId)}
        style={{ cursor: "pointer" }}
      >
        {this.state.checked &&
          (selectedCondominio === "all" ? (
            <div className="icon-check" style={{ display: "flex" }}>
              <p style={{ margin: 0 }}>
                {CondominioService.selectMany &&
                  CondominioService.selectMany.length > 0 &&
                  CondominioService.selectMany.filter(
                    (select) => select.idservice === this.props.image
                  ).length}
              </p>
              <IconCheck color="#00a326" size={24} />
            </div>
          ) : (
            <IconCheck className="icon-check" color="#00a326" size={28} />
          ))}
        {this.props.title && <p className="title">{this.props.title}</p>}
        {(() => {
          const img = this.filterImage();
          const imgClass =
            this.props.cardClass !== "service" ? "image" : "imgservice";
          return typeof img === "function" ? (
            React.createElement(img, { className: imgClass })
          ) : (
            <img src={img} alt="Logo" className={imgClass} />
          );
        })()}
      </div>
    );
  }
}
